import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Restrict a single-precision floating-point number to a specified range.
*
* @module @stdlib/math/base/special/clampf
*
* @example
* var clampf = require( '@stdlib/math/base/special/clampf' );
*
* var v = clampf( 3.0, 0.0, 5.0 );
* // returns 3.0
*
* v = clampf( -3.0, 0.0, 5.0 );
* // returns 0.0
*
* v = clampf( 10.0, 0.0, 5.0 );
* // returns 5.0
*
* v = clampf( -0.0, 0.0, 5.0 );
* // returns 0.0
*
* v = clampf( 0.0, -0.0, 5.0 );
* // returns 0.0
*
* v = clampf( NaN, 0.0, 5.0 );
* // returns NaN
*
* v = clampf( 0.0, NaN, 5.0 );
* // returns NaN
*
* v = clampf( 3.14, 0.0, NaN );
* // returns NaN
*/

// MODULES //
var clampf = __var_0__;


// EXPORTS //
export default clampf;
